import React, { useEffect, useState } from "react";
import { Table, Segment, Header, Icon } from "semantic-ui-react";
import { generateSchema } from "../../../../helpers/schemaGenerator";

import "./ApplicantViewSegment.styles.scss";

const ApplicantViewSegment = ({
  initialOpen,
  data,
  label,
  hint,
  applicant,
  schemaData,
  changeState,
  errors,
  customData,
  openAllSection,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if(openAllSection) setOpen(true);
    else setOpen(false);
  },[openAllSection])

  useEffect(() => {
    if(initialOpen) setOpen(true)
  }, [initialOpen])

  return (
    <React.Fragment>
      <Table.Row>
        <Table.Cell colSpan="2">
          <h2
            className={`segment-toggle ${open ? "segment-toggle--open" : ""}`}
            onClick={() => setOpen((prev) => !prev)}
          >
            {label}
          </h2>
        </Table.Cell>
      </Table.Row>
      {open && (
        <React.Fragment>
          {label === "General application information" &&
            applicant?.api === "ds82" &&
            applicant?.onlineRenewalEligibility !== undefined && (
              <Table.Row>
                <Table.Cell colSpan="2">
                  <Segment
                    color={
                      applicant.onlineRenewalEligibility ? "green" : "orange"
                    }
                  >
                    <Header
                      as="h4"
                      color={
                        applicant.onlineRenewalEligibility ? "green" : "orange"
                      }
                    >
                      <Icon
                        name={
                          applicant.onlineRenewalEligibility
                            ? "check circle"
                            : "info circle"
                        }
                      />
                      <Header.Content>
                        {applicant.onlineRenewalEligibility
                          ? "Online Renewal Eligible"
                          : "Not Eligible for Online Renewal"}
                      </Header.Content>
                    </Header>
                  </Segment>
                </Table.Cell>
              </Table.Row>
            )}
          {hint && (
            <Table.Row>
              <Table.Cell colSpan="2">{hint}</Table.Cell>
            </Table.Row>
          )}
          {customData
            ? customData
            : generateSchema(data, applicant, schemaData, changeState, errors)}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ApplicantViewSegment;
